export default {
    //免密登录token
    noLogin: "/auth/changeLogin",
    //  user 获取APPuser 列表
    getAppUserList: "/userManagement/appUser/show",
    // user APP user 修改密码
    getAppUserUpdatePassword: "/userManagement/appUser/updatePassword",
    // 登录
    getLogin: "/auth/login",
    // 根据email获取邮箱验证码
    sendVerificationCode: "/auth/sendVerificationCodeToRetrieve",
    //   User Managment  App user add  新增App 用户
    getAppUserAdd:"/userManagement/appUser/add",
    // 获取到tenant 
    getTenantList:"/userManagement/appUser/searchTenant",
    // 校验用户当前密码强度 
    checkEncryptPasswordStrength: "/userManagement/password/checkEncryptPasswordStrength",
    // 校验明文密码强度
    checkDecryptPasswordStrength: "/userManagement/password/checkDecryptPasswordStrength",
    // 重置token
    restToken: "/auth/restToken",
};
